<script setup>

import {computed, ref} from "vue";
import AddInsightsDomainWithParser from "../../addInsights/domainWithParser.vue";

const emit = defineEmits(['markTaskSkipped', 'openEmail', 'openInSidebar'])

const props = defineProps({
    task: {
        type: Object,
        required: true
    }
})

const addInsightsDomain = ref(null)
const addInsightsEmail = ref(null)

const addInsights = (task) => {
    addInsightsDomain.value = task.domain
    addInsightsEmail.value = task.email
}

const onInsightsClose = () => {
    addInsightsDomain.value = null
    addInsightsEmail.value = null
}

const displayAddInsights = computed(() => {
    return addInsightsDomain.value !== null || addInsightsEmail.value !== null
})


</script>

<template>
    <div
        class="flex justify-between py-3"
    >
        <div
            class="grid w-full grid-cols-5 gap-y-1 gap-x-4"
            :class="task.done ? 'text-gray-400' : ''"
        >
            <div class="flex col-span-5">
                <div class="w-full">
                    <div class="font-bold" :class="{'line-through': task.done}">{{ task.name }}</div>
                </div>
            </div>

            <div class="flex flex-col col-span-2">
                <div class="flex flex-col space-y-1">
                    <div class="flex flex-col w-full">
                        <span>{{ task.job_title }}</span>
                        <div class="mt-1 text-xs">{{ task.company }}</div>
                        <small
                            class="mt-2 text-gray-500"
                        >Found at {{ task.found_at }}</small>
                        <small
                            class="mt-2 text-myflowGreen-900"
                            v-if="task.leadExists"
                        >Already in your contacts</small>
                    </div>
                </div>
            </div>
            <div class="flex flex-col col-span-3 space-y-1">
                <a
                    :href="task.linkedin_url"
                    target="_blank"
                    class="flex items-center text-lg leading-none hover:text-gray-500"
                >
                    <i class="w-5 text-gray-500 fa-brands fa-linkedin"></i>
                    <span class="pl-1 text-xs">LinkedIn</span>
                </a>
                <div class="flex items-center">
                    <span
                        class="text-lg leading-none cursor-pointer hover:text-gray-500"
                    >
                        <a :href="'mailto:'+task.email" target="_blank">
                            <i class="w-5 text-gray-500 fa-regular fa-envelope"></i>
                        </a>
                    </span>
                    <span
                        class="pl-1 text-xs truncate select-all"
                    >{{ task.email }}</span>
                </div>
                <div>
                    <button-transparent
                        size="line"
                        @click="addInsights(task)"
                    >
                        <span class="flex items-center">
                            <span
                                class="text-lg leading-none cursor-pointer hover:text-gray-500"
                            >
                                <i class="w-5 text-gray-500 fa-regular fa-head-side-brain"></i>
                            </span>
                            <span class="pl-1 text-xs">Insights</span>
                        </span>
                    </button-transparent>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-2 text-center">
            <button-primary
                v-if="!task.done"
                @click="emit('openInSlideout',task)"
                size="sm"
                class="justify-center whitespace-nowrap"
            >
                Continue
            </button-primary>

            <button-base
                v-if="task.done"
                @click="emit('openInSlideout',task)"
                size="sm"
                class="justify-center w-24 whitespace-nowrap"
            >
                View
            </button-base>

            <button-base
                v-if="!task.done"
                @click="emit('markTaskSent',task)"
                size="sm"
                class="justify-center whitespace-nowrap"
            >
                Mark as sent
            </button-base>

            <button-base
                v-if="task.done"
                size="sm"
                disabled
                class="justify-center w-24 whitespace-nowrap"
            >
                Sent
            </button-base>

            <button-danger
                v-if="!task.done"
                @click="emit('markTaskSkipped', task)"
                size="sm"
                class="justify-center whitespace-nowrap"
            >
                Skip
            </button-danger>

            <button-danger
                v-if="task.done"
                size="sm"
                disabled
                class="justify-center whitespace-nowrap"
            >
                Skip
            </button-danger>
        </div>
    </div>
    <add-insights-domain-with-parser
        v-if="displayAddInsights"
        :domain="addInsightsDomain"
        :email="addInsightsEmail"
        @close="onInsightsClose"
    />
</template>

<style scoped>

</style>
